import React from 'react';
import { JoiningBonusModal } from './JoiningBonusModal';
import { useJoiningBonus } from '@/contexts/JoiningBonusContext';

export const GlobalJoiningBonusModal = () => {
  const { showJoiningBonusModal, dismissJoiningBonusModal } = useJoiningBonus();

  return (
    <JoiningBonusModal 
      isOpen={showJoiningBonusModal}
      onClose={dismissJoiningBonusModal}
    />
  );
};